module.exports = __webpack_public_path__ + "static/media/view5.e33e201b.jpg";